import { Box, Card, Container, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function Report() {
  return (
    <>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายงาน
        </h6>
        <h3 style={{ marginTop: "10px" }} className="textcolordarkblue">
          Report
        </h3>

        <Container maxWidth="xl">
          <Box sx={{ marginTop: "50px" }}>
            <Link to="/EmptyContainer" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>1.</span> Empty Container
                Planning Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/LadenContainer" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>2.</span> Laden Container
                Planning Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/Expense" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>3.</span>  Expense Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/AdvancePayment" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>4.</span>  Advance Payment Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/SaleOrderCostReport" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>5. </span>
                Sale Order Cost Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/TrainCostReport" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>6.</span> Train Cost Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/ShipCostReport" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>7.</span> Ship Cost Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/ReportRevenue" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>8.</span> Revenue Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/SaleOrderMAC-5Report" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>9. </span>
                Sale Order (MAC-5) Report
              </Typography>
            </Link>
          </Box>
          <Box sx={{ marginTop: "20px", marginBottom: "25px" }}>
            <Link to="/DailyMovement-Report" style={{ color: "#000" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  transition: "0.3s",
                  ":hover": {
                    color: "#80c340",
                  },
                }}
              >
                <span style={{ color: "#000" }}>10. </span>
               Daily Movements Report
              </Typography>
            </Link>
          </Box>
        </Container>
      </Card>
    </>
  );
}
